import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import { customListApi } from '../apis';
import { CustomListType, fetchCustomListsSuccess } from './customListsReducer';
import { InternalApiCustomList } from '../api-internal';

let requestPromise: Promise<InternalApiCustomList[]> | null = null;

const noCustomLists: CustomListType[] = [];
const useCustomLists = () => {
  const dispatch = useDispatch();
  const { customLists } = useSelector((state: AppState) => state.customLists);

  useEffect(() => {
    if (customLists === null && requestPromise == null) {
      requestPromise = customListApi.getLists();
      requestPromise
        .then((newCustomLists) => {
          dispatch(fetchCustomListsSuccess(newCustomLists));
          requestPromise = null;
        })
        .catch(() => {
          requestPromise = null;
        });
    }
  }, [customLists]);

  return customLists ?? noCustomLists;
};

export default useCustomLists;
